<template>
    <div>
        <div class="blog-post bg-grey pt-120 position-relative">
            <div class="d-flex align-items-center px-5 acumin-pro-wide-light">
                The SouthBay Blog <div class="hyphenated"></div>
            </div>
            <b-container class="mt-5">
                <div class="freight-big-pro-book h1" role="heading" v-if="blogContent.heading" v-html="blogContent.heading">
                </div>
                <div class="mt-4" v-if="blogContent.date">
                    {{ blogContent.date }}
                </div>
            </b-container>
            
            <div class="mt-5" v-if="blogContent.heroImg">
                <img :src="blogContent.heroImg" :alt="blogContent.heroImgAlt" class="w-100 d-block">
            </div>
            <b-container>
                <div class="acumin-pro-wide-light mt-80" v-if="blogContent.copy_below_hero" v-html="blogContent.copy_below_hero"></div>
                <div v-if="blogContent.images_set_1">
                    <b-row>
                        <b-col v-for="(blogImg, i) in blogContent.images_set_1" :key="i" :lg="blogImg.cols" class="mt-40">
                            <div>
                                <img :src="blogImg.img" :alt="blogImg.alt" class="w-100 d-block">
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div class="acumin-pro-wide-light mt-80" v-if="blogContent.copy_below_image_set_1" v-html="blogContent.copy_below_image_set_1"></div>

                <div v-if="blogContent.images_set_2">
                    <b-row>
                        <b-col v-for="(blogImg, i) in blogContent.images_set_2" :key="i" :lg="blogImg.cols" class="mt-40">
                            <div>
                                <img :src="blogImg.img" :alt="blogImg.alt" class="w-100 d-block">
                            </div>
                        </b-col>
                    </b-row>
                </div>

                <div class="acumin-pro-wide-light mt-60" v-if="blogContent.copy_below_image_set_2" v-html="blogContent.copy_below_image_set_2"></div>
                <BlogPageControls :blogId="blogId"/>
            </b-container>
            <AppFooter class="mt-5"/>
            <PresentationCenter id="presentation"/>
        </div>
    </div>
</template>

<script>
import BlogPageControls from '@/components/BlogPageControls';
import blogItems from '@/json/blog';
import AppFooter from '@/components/AppFooter'
import PresentationCenter from '@/components/PresentationCenter'

export default {
    props: ['blogId'],
    data() {
        return {
            blogContent: {}
        }
    },
    components: {
        BlogPageControls,
        AppFooter,
        PresentationCenter
    },
    mounted() {
        var currentBlog = blogItems.data.filter(item => {
            return item.id == this.blogId
        });
        this.blogContent = currentBlog["0"];
    }
}
</script>

<style scoped lang="scss">
.blog-post {
    .hyphenated {
        height: 1px;
        width: 20px;
        background-color: #0b2340;
        margin-left: 15px;
    }
}
</style>